define('view/disclosure/disclosure.download',['require','exports','module','uikit/uikit'],function(require, exports, module) {

    var UIKit = require('uikit/uikit');

    var DisclosureDownload = UIKit.ItemView.extend({

        template: function(attributes) {

            var html = '<div>';

            var documents = (attributes.model && attributes.model.documents)
                ? attributes.model.documents
                : [];
            
            documents.forEach(function(document) {
                var name = (document.name && document.name.length > 50) ?  document.name.substring(0, 50) : document.name;
                html += '<span  data-url="' + document._links.self.href + '">' + name + '</span></br>';
            });

            html += '</div>';
            
            return html;
        },

        className: 'disclosure-download',

        triggers: {
            mousedown: { event: 'before:press', preventDefault: true, stopPropagation: true}
        },

        events: {
            click: function(event) {

                event.preventDefault();

                var url = event.target.getAttribute('data-url');

                // Run XHR call
                var request = new XMLHttpRequest();

                request.open(
                    'GET',
                    url
                );
                var authorization = 'Bearer '+ localStorage.getItem('fk_accessToken');
                request.setRequestHeader('Authorization', authorization );
                request.setRequestHeader('X-IDP-New-Login', true);
                request.responseType = 'blob';

                request.onload = function() {
                    if (request.status == 200) {
                        var blob;
                        if (request.getResponseHeader('content-type')) {
                            blob = new Blob([request.response], {
                                type: request.getResponseHeader('Content-Type'),
                            });
                        } else {
                            blob = new Blob([request.response], { type: 'text/plain' });
                        }

                        var a = document.createElement('a');
                        a.style.display = 'none';
                        var contentDisposition = request.getResponseHeader('content-disposition');
                        if (contentDisposition !== null && contentDisposition.indexOf('filename="') !== -1) {
                            a.download = contentDisposition.split('"')[1];
                        } else {
                            a.download = 'attachment';
                        }
                        var url = window.URL.createObjectURL(blob);
                        a.href = url;
                        document.body.appendChild(a);
                        a.click();
                        a = null;
                        window.open(url, '_blank');
                    }
                };

                request.send();
            }
        },
    });

    module.exports = DisclosureDownload;
});


